<template>
  <collapsible-section title="PIM_PRODUCT-ACCORDION_TITLE-BASIC_DATA" :defaultOpen="defaultOpen">

    <!-- name -->
    <form-input
      inputType="text"
      :label="'PIM-PRODUCT-NAME' + labelSuffix"
      v-model="product.names.pim"
    ></form-input>

    <ul class="otherValuesContainer" v-if="pharmacy == null">
      <li
        v-for="(val, key) in product.names"
        class="otherValues"
        v-if="key != 'pim' && val != ''"
      >
        <span class="key">
          <lang :labelKey="'PIM-PRODUCT-NAME-' + key"></lang>: </span
        ><br /><span class="value">{{ val }}</span
        ><br />
      </li>
    </ul>
    
    <!-- EAN CODES and extref -->
    <div style="display: flex; gap: 16px; margin-bottom: 10px;">
      <div style="flex: 1;">
        <!-- EAN CODES -->
        <form-input
          inputType="text"
          :label="'PIM-PRODUCT-EAN' + labelSuffix"
          v-model="product.barcodes_stringified"
          :isReadOnly="true"
        ></form-input>
      </div>

      <div style="flex: 1;">
        <!-- extref -->
        <form-input
          inputType="text"
          :label="'PIM-PRODUCT-EXTREF' + labelSuffix"
          v-model.trim="product.extRef"
          :isReadOnly="isReadonly"
        ></form-input>
      </div>
    </div>

    <!-- manufacturers -->
    <template
      v-if="
        product.manufacturerNames && product.manufacturerNames.length
      "
    >
      <form-input
        inputType="text"
        :label="'PIM-PRODUCT-MANUFACTURERS' + labelSuffix"
        v-model="product.manufacturerNames.pim"
        v-bind:key="key"
      ></form-input>

      <ul class="otherValuesContainer">
        <li
          v-for="(value, key) in product.manufacturerNames"
          :key="key"
          v-if="key != 'pim' && value != null"
          class="otherValues"
        >
          <span class="key">
            <lang
              :labelKey="
                'PIM-PRODUCT-MANUFACTURERS-' + key + labelSuffix
              "
            ></lang
            >: </span
          ><br />
          <span class="value">{{ value }}</span
          ><br />
        </li>
      </ul>
    </template>

    <!-- manufacturer (brand) -->
    <form-input
      inputType="text"
      :label="'PIM-PRODUCT-MANUFACTURER' + labelSuffix"
      v-model="product.manufacturerName"
    ></form-input>

    <!-- category -->
    <div class="control" style="margin-top: 24px;">
      <div class="control-label">
        <label-name :labelKey="'PIM-PRODUCT-CATEGORY' + labelSuffix"></label-name>
      </div>

      <div class="control">
        <ProductSectionCategory
          ref="categorySection"
          :pharmacy="pharmacy"
          :initialCategoryId="product.category"
          @category-change="onCategoryChange"
        />
      </div>
    </div>

    <!-- LOYALTY POINTS -->
    <template v-if="loyaltyPoints">
      <div class="control">
        <div class="control-label">
          <label-name :labelKey="'PIM-PRODUCT-LOYALTYPOINTS' + labelSuffix"></label-name>
        </div>

        <div class="control">
          <div style="display: flex; flex-direction: column;  gap: 6px 12px; background-color: #f5f5f5; border-radius: 2px; padding: 8px; margin-bottom: 12px;">

            <div v-if="loyaltyPoints" style="display: flex; align-items: center;">
              {{ loyaltyPoints.loyaltyPoints }}
              <span class="material-symbols-outlined has-pointer" title="Zeige Informationen" style="font-size: 18px; margin-left: 4px;" @click="openLoyaltyPointsModal(loyaltyPoints.info.loyaltyPoints)">info</span>
            </div>

            <div v-for="(customerGroupValue, customerGroupKey) in loyaltyPoints.customerGroups" v-if="loyaltyPoints.customerGroups && loyaltyPoints.customerGroups.length > 0"style="display: flex; align-items: center;">
              {{ customerGroupKey }}: {{ customerGroupValue }}
              <span class="material-symbols-outlined has-pointer" title="Zeige Informationen" style="font-size: 18px; margin-left: 4px;" @click="openLoyaltyPointsModal(loyaltyPoints.info.customerGroups[customerGroupKey])">info</span>
            </div>

          </div>
        </div>
      </div>

      <!-- loyaltyPoints Calculation Modal-->
      <VerboseCalculationModal
        :showModal="showLoyaltyPointsModal"
        :loyaltyPoints="loyaltyPoints.loyaltyPoints"
        :informationData="loyaltyPointsData"
        @close="onCloseLoyaltyPointsModal"
      />
    </template>

    <!-- Sanova Download Platform -->
    <template v-if="activeUser.userRole.name === 'Administrator JTM' || activeUser.userRole.name === 'Administrator'">

      <!-- sanov toggler -->  
      <div class="control">
        <div class="control-label">
          <label-name labelKey="PIM-PRODUCT-SANOVA_PRODUCT"></label-name>
        </div>
        <div class="control">
          <b-switch
          v-model.sync="product.sanovaDownloadPlatform"
          type="primary"
          size="small"
          
          ></b-switch>
        </div>
      </div>
      
      <!-- approvalCode only for Active Sanova Platform -->
      <form-input 
        v-if="product.sanovaDownloadPlatform"
        inputType="text"
        :label="'PIM-PRODUCT-APPROVAL_CODE' + labelSuffix"
        v-model="product.approvalCode"
      ></form-input>

    </template>

  </collapsible-section>
</template>

<script>
import CollapsibleSection from "../../utils/CollapsibleSection.vue";
import VerboseCalculationModal from "../verboseCalculationModal.vue";
import ProductSectionCategory from "./ProductSectionCategory.vue";

export default {
  name: "ProductSectionBasicData",

  components: {
    CollapsibleSection,
    VerboseCalculationModal,
    ProductSectionCategory,
  },

  props: {
    product: { type: Object, required: true },
    pharmacy: { type: Object, default: null },
    isReadonly: { type: Boolean, default: false },
    labelSuffix: { type: String, default: "" },
    loyaltyPoints: { type: Object, default: null },
    defaultOpen: { type: Boolean, default: false },
  },

  data() {
    return {
      showLoyaltyPointsModal: false,
      loyaltyPointsData: null,
    };
  },

  methods: {

    onCategoryChange(categoryId) {
      this.$set(this.product, 'category', categoryId);
    },

    openLoyaltyPointsModal(data) {
      this.loyaltyPointsData = data;
      this.showLoyaltyPointsModal = true;
    },

    onCloseLoyaltyPointsModal() {
      this.showLoyaltyPointsModal = false;
      this.loyaltyPointsData = null;
    },
  },
};
</script>

<style scoped lang="scss">
.otherValuesContainer {
  padding-left: 10px;
  margin: 0 0 40px 0;
  display: block;
  border: none;

  li.otherValues {
    background: #f0f1f2;
    border-radius: 3px;
    margin-bottom: 3px;
    padding: 2px 5px;
    white-space: normal;

    .key {
      display: inline-block;
      font-weight: 400;
      overflow: hidden;
      margin-right: 8px;
      font-size: 11px;
      text-transform: uppercase;
    }

    .value {
      font-size: 11px !important;
      width: 440px;

      p {
        padding-bottom: 10px;
      }
    }
  }
}
</style>
